import { useGSAP } from '@gsap/react'
import React, { useRef } from 'react'
import { animateWithGsaP } from '../utils/animations'
import { explore1Img, explore2Img, exploreVideo } from '../utils'
import gsap from 'gsap'

const Features = () => {
    const videoRef = useRef();
    useGSAP(()=>{
        gsap.to('#exploreVideo',{
            scrollTrigger:{
                trigger: '#exploreVideo',
                toggleActions:'play pause reverse restart',
                start: '-10% bottom',
            
            },
            onComplete:()=>{
                videoRef.current.play()
            }
        })
    
animateWithGsaP('#features_title',{y:0, opacity:1})
animateWithGsaP('.g_grow',{scale:1, opacity:1, ease:'power1'}, {scrub:5.5})
animateWithGsaP('.g_text', {y:0, opacity:1, ease:'power2.inOut', duration:1})
    }, [])
  return (
    <section className='h-full common-padding bg-zinc relative overflow-hidden'>
        <div className='screen-max-width'>
            <div className='mb-12 w-full'>
                <h1 id='features_title' className='section-heading'> Explore the full story

                </h1>

            </div>
            <div className='flex flex-col justify-center items-center overflow-hidden'>
                <div className='mt-32 mb-24 pl-24'>
                    <h2 className='text-5xl lg:text-7xl font-semibold'>
                        Iphone
                    </h2>
                    <h2 className='text-5xl lg:text-7xl font-semibold'>
                        Forged in Titanium
                    </h2>

                </div>
                <div className='flex-center flex-col sm:px-10'>
                    <div className='relative h-[50vh] w-full flex items-center'>
                        <video playsInline id='exploreVideo' className='w-full h-full object-cover object-center' preload='none' muted autoPlay ref={videoRef}>

                            <source src={exploreVideo} type='video/mp4'/>
                        </video>

                    </div>
                    <div className='flex flex-col w-full relative'>
                        <div className='feature-video-container'>
                            <div className='overflow-hidden flex-1 h-[50vh]'>
                              <img src={explore1Img} alt='titanium' className='feature-video g_grow'/>

                            </div>
                            <div className='overflow-hidden flex-1 h-[50vh]'>
                              <img src={explore2Img} alt='titanium2' className='feature-video g_grow'/>

                            </div>

                        </div>
                        <div className='feature-text-container'>
                            <div className='flex-1 flex-center'>
                                <p className='feature-text g_text'>
                                    Iphone 15 pro {''}
                                    <span className='text-white'>
                                    First iPhone to feature a titanium frame for added strength and reduced weight.
A17 Pro chip for faster performance and advanced gaming capabilities.
USB-C port replaces Lightning

                                    </span>,offering faster data transfer and universal charging compatibility.


                                </p>

                            </div>
                            <div className='flex-1 flex-center'>
                                <p className='feature-text g_text'>
                                    Iphone 15 pro {''}
                                    <span className='text-white'>
                                    Step into the future with the iPhone 15 Pro, designed for those who demand more. Featuring an aerospace-grade titanium frame, it’s lighter, stronger, and built to last.

                                    </span>,Capture every detail with the stunning 48MP Pro camera system, offering up to 5x optical zoom and next-level low-light photography.


                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    
    
    </section>
  )
}

export default Features